/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['../constants'], function(constants) {
	'use strict';
	class Rave2bundlepackedbubble {
		get config(){
			return {
				'type':'PackedBubble',
				'disablePan':true,
				'thumbnail': {
					'type': 'img'
				},
				'propertiesToSetBeforeData': [
					'widget.data.truncate'
				],
				'listenForPropChanges': [
					'widget.legend.size'
				],
				'slots':{
					'categories':{
						'optional':false,
						'icon':'bubbles'
					},
					'color':{
						'optional':true,
						'sort':'asc',
						'icon':'colorBy',
						'supportsMaintainAxisScale': true,
						'mldTitleProperty': 'color.title',
						'tags': ['canUseToColor']
					},
					'size':{
						'optional':true,
						'icon':'size_by',
						'mldTitleProperty': 'size.title',
						'sortable': false
					},
					'repeatHorizontal':{
						'icon':'multiplier_h',
						'sort':'asc'
					},
					'repeatVertical':{
						'icon':'multiplier_v',
						'sort':'asc'
					}
				},
				'propertyPrefixes': {
					'dataPoint': 'labels',
					'categories': 'labels',
					'size': 'widget.legend',
					'color': 'widget.legend',
					'legend': 'widget.legend',
					'row': 'widget.repeatVertical.labels',
					'column': 'widget.repeatHorizontal.labels'
				},
				'groupedProperty': {
					'widget.legend.color': ['widget.legend.titleColor'],
					'widget.legend.font': ['widget.legend.titleFont']
				},
				'properties':{
					'color.title': {
						'multilingual': true
					},
					'size.title': {
						'multilingual': true
					},
					'widget.data.truncate': {
						active: false,
						defaultValue: true
					},
					'format.compact':{
						'active':false
					},
					'legendPosition':{
						'active':false
					},
					'legend.display':{
						'active':false
					},
					'pack':{
						'active':false,
						'defaultValue':'BubbleLayout',
						'isReadOnly': true
					},
					'dataHandling':{
						'active':false,
						'defaultValue':'tabular',
						'isReadOnly': true
					},
					'effect.duration': {
						'active': false,
						'defaultValue': constants.LONG_EFFECT_DURATION
					},
					'widget.legend.size': {
						'active': false
					},
					'labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 8
					},
					'widget.legend.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.titleColor': {
						'colorClass': true,
						'active': true
					},
					'contrast.label.color': {
						'defaultValue': true
					},
					'itemAxis.line.color':{
						'colorClass': true,
						'addButton': true
					},
					'valueAxis.line.color':{
						'colorClass': true,
						'addButton': true
					},
					'itemAxis.ticks.labels.rotateAngle': {
						'percentage': false
					},
					'widget.repeatHorizontal.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.repeatVertical.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					}
				},
				'queryHints':{
					'multiEdgeSort':true
				},
				config:{
					'include':[
						'widget.data.truncate',
						'widget.iterator',
						'widget.legend.display',
						'widget.legend.position',
						'labels.visible',
						'labels.format',
						'backgroundColor',
						'widget.legend.backgroundColor',
						'effect.duration',
						'labels.color',
						'labels.font',
						'contrast.label.color',
						'label.shadow',
						'pack',
						'dataHandling',
						'widget.legend.color',
						'widget.legend.splitter',
						'widget.legend.font',
						'widget.legend.titleColor',
						'widget.legend.titleFont',
						'widget.legend.swatch.symbol.default',
						'widget.repeatHorizontal.labels.color',
						'widget.repeatVertical.labels.color',
						'widget.repeatHorizontal.labels.font',
						'widget.repeatVertical.labels.font',
						'colors.categories',
						'colors.color',
						'widget.legend.size',
						'widget.legend.titleVisible',
						'color.title',
						'size.title',
						'itemAxis.line.color',
						'valueAxis.line.color',
						'itemAxis.line.visible',
						'valueAxis.line.visible',
						'itemAxis.ticks.labels.rotateAngle'
					],
					'exclude':[
					]
				},
				'usages':[
					'PartsToWhole'
				],
				'supportsMaintainAxisScale': false
			};
		}
	}
	return Rave2bundlepackedbubble;
});
